import { useState } from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { jwtDecode } from "jwt-decode";
import { useNavigate as useReactRouterNavigate } from 'react-router-dom';
import CompanyLogo from '../components/CompanyLogo';

export default function Login() {
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useReactRouterNavigate();

  const handleGoogleSuccess = async (credentialResponse) => {
    setError('');
    setLoading(true);
    try {
      const decoded = jwtDecode(credentialResponse.credential);
      const email = decoded.email;

      // Restrict domain
      if (!email.endsWith('@tmhwst.toyota-industries.com')) {
        setError('Access denied. Please use your @tmhwst.toyota-industries.com account.');
        setLoading(false);
        return;
      }

      // Send to PHP Backend on the live server
      const response = await fetch('/api/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token: credentialResponse.credential, email: email })
      });

      const data = await response.json();

      if (data.status === 'success') {
        // Save user data (including role and team_id) to localStorage
        localStorage.setItem('user', JSON.stringify(data.user));
        
        // Log the login activity
        fetch('/api/log_activity', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            email: data.user.google_email,
            action_type: 'LOGIN',
            details: 'User logged in'
          })
        }).catch(err => console.error('Failed to log login:', err));

        navigate('/'); // Redirect to dashboard
      } else {
        setError(data.message || 'Login failed from server.');
      }
    } catch (err) {
      console.error(err);
      setError('An error occurred during login.');
    }
    setLoading(false);
  };

  return (
    <div className="login-container">
      <div className="login-card">
        {/* Corporate Logo */}
        <CompanyLogo variant="login" />

        <h2 style={{ color: '#111827', fontSize: '1.65rem', fontWeight: 800, marginBottom: '0.5rem', letterSpacing: '-0.5px' }}>
          Salesvigator
        </h2>
        <p style={{ color: '#4b5563', marginBottom: '2rem', fontSize: '0.9rem', lineHeight: 1.5 }}>
          กรุณาเข้าสู่ระบบด้วยบัญชี @tmhwst.toyota-industries.com
        </p>
        
        {error && (
          <div style={{ color: '#b91c1c', backgroundColor: '#fef2f2', border: '1px solid #fecaca', padding: '0.75rem', borderRadius: '8px', marginBottom: '1.25rem', fontSize: '0.875rem' }}>
            {error}
          </div>
        )}
        
        {loading && (
          <p style={{ marginBottom: '1rem', color: '#eb0a1e', fontWeight: 600 }}>
            Authenticating...
          </p>
        )}

        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <GoogleLogin
            onSuccess={handleGoogleSuccess}
            onError={() => {
              setError('Google Sign-In failed.');
            }}
            useOneTap
            theme="filled_blue"
            shape="rectangular"
          />
        </div>
      </div>
    </div>
  );
}
